<template>
  <main class="ordre">
    <div class="container">
      <div class="jumbotron"><h3>Ajoutez un nouveau ordre</h3><hr/>
        <form @submit.prevent="onSubmit">
          <div class="form-row">
            <div class="form-group col-sm-6">
              <label class="">Masse à générer</label>
              <input type="text" class="form-control" v-model="payload.amount">
            </div>
            <div class="form-group col-sm-6">
              <label class="">Nombre</label>
              <input type="number" class="form-control" v-model="payload.number">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-sm-6">
              <label class="">Date Procès</label>
              <input type="date" class="form-control" v-model="payload.pvDate">
            </div>
            <div class="form-group col-sm-6">
              <label class="">Pièce jointe procès</label>
              <input type="file" class="form-control-file" ref="files" @change="handle">
            </div>
          </div>
          <div class="form-group">
            <label class="">Code</label>
            <input type="password" class="form-control"  v-model="payload.content" autocomplete>
          </div>
          <hr class="my-4">
          <p>It uses utility classes for typography and spacing to space content out within the larger container.</p>
          <div class="form-group">
            <button type="submit" :class="[{ 'disabled': loading }, 'btn btn-outline-warning btn-lg']">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading"></span>
              Valider
            </button>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>

<script>

export default {
  name: 'ordre',
  data() {
    return {loading: false, payload: {type: 'ordre', amount: 0}}
  },
  methods: {
    handle(e){
      var file = e.target.files[0];
      if(file) this.payload.pvUrl = file.name;
    },
    onSubmit() { 
      this.loading = true;
      this.$store.dispatch('transact/insertTrans', this.payload).then(
        () => {
          this.payload = {type: 'ordre', amount: 0}; 
          this.loading = false
        }
      )
    }
  },
}
</script>

<style scoped lang="scss">

</style>
